<template>
  <div
    class="LKPublicationsStorageFileIcon"
    :style="style"
    v-text="ext"
  />
</template>

<script>
import { toHexColor } from '@/helpers/getColor'


export default {
  name: 'LKPublicationsStorageFileIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    filename: {
      type: String,
      required: true,
    },
    ext: {
      type: String,
      validator: (v) => typeof v === 'string' || !v,
    },
  },
  computed: {
    style() {
      const { ext } = this
      const color = ext ? toHexColor(ext) : 'white'
      return { backgroundColor: color }
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsStorageFileIcon {
  position: relative;
  display: flex;
  align-items: flex-end;
  min-width: 25px;
  height: 36px;
  padding: 2px 4px;
  overflow: hidden;
  font-size: 9px;
  font-weight: 900;
  color: $webflow-color-white;
  text-shadow: 0 0 2px rgb(0 0 0 / 50%);
  background-color: $webflow-color-orange-2;
  border-radius: 4px;

  &::after {
    position: absolute;
    top: -11px;
    right: -11px;
    display: block;
    width: 20px;
    height: 20px;
    content: "";
    background-color: rgb(0 0 0 / 10%);
    transform:
      rotate(
        45deg
      );
  }
}
</style>
